export const DESIGN_RES = {
    portrait: {
        width: 1080,
        height: 1920,
    },
    landscape: {
        width: 1920,
        height: 1080,
    },
};
export const CAM_CENTER = {
    x: 0,
    y: 0,
};
export const MAX_RES = {
    width: 1920,
    height: 1080,
};
